var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatXls = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_131219)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_213_131219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 32H7.79982C5.14885 32 2.99982 29.851 2.99982 27.2V4.8C2.99982 2.14903 5.14885 0 7.79982 0H16.4709C17.731 0 18.9406 0.495552 19.8386 1.37968L27.5675 8.98974C28.4838 9.89196 28.9998 11.1241 28.9998 12.4101V27.2C28.9998 29.851 26.8508 32 24.1998 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 31.4H7.79982C5.48022 31.4 3.59982 29.5196 3.59982 27.2V4.8C3.59982 2.4804 5.48022 0.6 7.79982 0.6H16.4709C17.5735 0.6 18.6319 1.03361 19.4176 1.80722L27.1466 9.41728C27.9483 10.2067 28.3998 11.2849 28.3998 12.4101V27.2C28.3998 29.5196 26.5194 31.4 24.1998 31.4Z",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 1V7.8C18 9.56731 19.4327 11 21.2 11H28",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_213_131219)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_213_131219",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H21C22.6569 14 24 15.3431 24 17V25C24 26.6569 22.6569 28 21 28H3C1.34315 28 0 26.6569 0 25V17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H21C22.6569 14 24 15.3431 24 17V25C24 26.6569 22.6569 28 21 28H3C1.34315 28 0 26.6569 0 25V17Z",
    fill: "#1F8957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.8 17C-0.8 14.9013 0.901318 13.2 3 13.2H21C23.0987 13.2 24.8 14.9013 24.8 17H23.2C23.2 15.785 22.215 14.8 21 14.8H3C1.78497 14.8 0.8 15.785 0.8 17H-0.8ZM24 28H0H24ZM3 28C0.901318 28 -0.8 26.2987 -0.8 24.2V17C-0.8 14.9013 0.901318 13.2 3 13.2V14.8C1.78497 14.8 0.8 15.785 0.8 17V25C0.8 26.6569 1.78497 28 3 28ZM21 13.2C23.0987 13.2 24.8 14.9013 24.8 17V24.2C24.8 26.2987 23.0987 28 21 28C22.215 28 23.2 26.6569 23.2 25V17C23.2 15.785 22.215 14.8 21 14.8V13.2Z",
    fill: "black",
    fillOpacity: 0.08,
    mask: "url(#path-4-inside-1_213_131219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6 17.6L6.00938 19.9437H6.05938L7.475 17.6H8.79688L6.825 20.8L8.82813 24H7.48438L6.05938 21.6719H6.00938L4.58438 24H3.24688L5.26875 20.8L3.27188 17.6H4.6ZM9.88303 24V17.6H11.0424V23.0281H13.8612V24H9.88303ZM18.5215 19.3594C18.4924 19.0865 18.3694 18.874 18.1528 18.7219C17.9382 18.5698 17.659 18.4937 17.3153 18.4937C17.0736 18.4937 16.8663 18.5302 16.6934 18.6031C16.5205 18.676 16.3882 18.775 16.2965 18.9C16.2049 19.025 16.158 19.1677 16.1559 19.3281C16.1559 19.4615 16.1861 19.5771 16.2465 19.675C16.309 19.7729 16.3934 19.8562 16.4997 19.925C16.6059 19.9917 16.7236 20.0479 16.8528 20.0937C16.9819 20.1396 17.1122 20.1781 17.2434 20.2094L17.8434 20.3594C18.0851 20.4156 18.3174 20.4917 18.5403 20.5875C18.7653 20.6833 18.9663 20.8042 19.1434 20.95C19.3226 21.0958 19.4642 21.2719 19.5684 21.4781C19.6726 21.6844 19.7247 21.926 19.7247 22.2031C19.7247 22.5781 19.6288 22.9083 19.4372 23.1937C19.2455 23.4771 18.9684 23.699 18.6059 23.8594C18.2455 24.0177 17.809 24.0969 17.2965 24.0969C16.7986 24.0969 16.3663 24.0198 15.9997 23.8656C15.6351 23.7115 15.3497 23.4865 15.1434 23.1906C14.9392 22.8948 14.8288 22.5344 14.8122 22.1094H15.9528C15.9694 22.3323 16.0382 22.5177 16.159 22.6656C16.2799 22.8135 16.4372 22.924 16.6309 22.9969C16.8267 23.0698 17.0455 23.1062 17.2872 23.1062C17.5392 23.1062 17.7601 23.0687 17.9497 22.9937C18.1413 22.9167 18.2913 22.8104 18.3997 22.675C18.508 22.5375 18.5632 22.3771 18.5653 22.1937C18.5632 22.0271 18.5142 21.8896 18.4184 21.7812C18.3226 21.6708 18.1882 21.5792 18.0153 21.5062C17.8444 21.4312 17.6444 21.3646 17.4153 21.3062L16.6872 21.1187C16.1601 20.9833 15.7434 20.7781 15.4372 20.5031C15.133 20.226 14.9809 19.8583 14.9809 19.4C14.9809 19.0229 15.083 18.6927 15.2872 18.4094C15.4934 18.126 15.7736 17.9062 16.1278 17.75C16.4819 17.5917 16.883 17.5125 17.3309 17.5125C17.7851 17.5125 18.183 17.5917 18.5247 17.75C18.8684 17.9062 19.1382 18.124 19.334 18.4031C19.5299 18.6802 19.6309 18.999 19.6372 19.3594H18.5215Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_213_131219",
    x: 1.39982,
    y: -3.2,
    width: 29.2,
    height: 37.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_213_131219"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_213_131219",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.813571 0 0 0 0 0.82 0 0 0 0 0.826429 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_213_131219"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_213_131219",
    x: 0,
    y: 14,
    width: 24,
    height: 17.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_213_131219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_131219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatXls);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FormatXls.9a57d378abb73eadce315d552a30bf6f.svg";